export { PLUGIN_KEY, PLUGIN_PRIORITY, ExportFile } from "./exportFile.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/exportFile/index.mjs
// module id = 1356
// module chunks = 1